import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";import React from 'react';
import clsx from 'clsx';
import capitalize from "../../helpers/capitalize";
import { Guideline } from "./..";

import ValidationBlock from "../ValidationBlock";
import { createStyles } from "./styles";

var Select = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var _props$value =
















    props.value,value = _props$value === void 0 ? '' : _props$value,name = props.name,options = props.options,onChange = props.onChange,description = props.description,label = props.label,id = props.id,form = props.form,_props$disabled = props.disabled,disabled = _props$disabled === void 0 ? false : _props$disabled,_props$type = props.type,type = _props$type === void 0 ? 'column' : _props$type,_props$validationPass = props.validationPassed,validationPassed = _props$validationPass === void 0 ? true : _props$validationPass,validationMessage = props.validationMessage,placeholder = props.placeholder,className = props.className,guidelines = props.guidelines,showGuidelinesByDefault = props.showGuidelinesByDefault;

  var classes = createStyles(props);
  var optionsIndexKey = 0;

  return /*#__PURE__*/(
    React.createElement("div", {
      id: "select-wrapper-".concat(id),
      className: clsx(classes.wrapper, classes["wrapper".concat(capitalize(type))], className) },

    (label || description) && /*#__PURE__*/
    React.createElement("div", { className: classes.descriptionWrapper }, /*#__PURE__*/
    React.createElement("label", { htmlFor: name, className: clsx(classes.label) },
    label), /*#__PURE__*/

    React.createElement("p", { className: classes.description }, description)), /*#__PURE__*/


    React.createElement("div", { className: classes.selectForChevronWrapper }, /*#__PURE__*/
    React.createElement("select", {
      value: value || '',
      name: name,
      onChange: onChange,
      id: id,
      form: form,
      disabled: disabled,
      className: clsx(
      classes.select,
      classes["selectValidation".concat(capitalize(validationPassed.toString()))],
      disabled && classes.selectDisabled),

      ref: ref }, /*#__PURE__*/

    React.createElement("option", { value: "", disabled: true, hidden: true },
    placeholder),

    _mapInstanceProperty(options).call(options, function (option) {
      optionsIndexKey += 1;
      return /*#__PURE__*/(
        React.createElement("option", { value: option.value, key: optionsIndexKey, className: classes.option },
        option.label));


    }))), /*#__PURE__*/


    React.createElement(ValidationBlock, {
      value: value,
      validationMessage: validationMessage,
      validationPassed: validationPassed }),

    guidelines && /*#__PURE__*/
    React.createElement(Guideline, {
      text: guidelines,
      showGuidelinesByDefault: showGuidelinesByDefault,
      className: classes.selectGuideline })));




});
Select.displayName = 'Select';

export default Select;
//# sourceMappingURL=index.js.map